import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const updateUserRoleScopes = (
  userId: number,
  usersScopeIds: number[] | null,
  cohortsScopeIds: number[] | null,
  projectGroupsScopeIds: number[] | null,
  organizersScopeIds: number[] | null,
  animatorsScopeIds: number[] | null,
  onSuccess: Function,
  language: string,
  setLoading: Function,
  isEdit: boolean
) => {
  setLoading(true);
  ApiService.put(`users/${userId}/roles/scopes`, {
    users_scope_ids: usersScopeIds,
    cohorts_scope_ids: cohortsScopeIds,
    project_groups_scope_ids: projectGroupsScopeIds,
    organizers_scope_ids: organizersScopeIds,
    animators_scope_ids: animatorsScopeIds,
  })
    .then(() => {
      alert(
        translate(
          language,
          isEdit ? "PAGES.USER_ROLES_SCOPES.SUCCESS.UPDATE_SCOPES" : "PAGES.USER_ROLES_SCOPES.SUCCESS.ADD_SCOPES"
        )
      );
      onSuccess();
    })
    .catch((err) => {
      console.error("Error updating user role scopes:", err);
      alert(translate(language, "PAGES.USER_ROLES_SCOPES.ERRORS.UPDATE_SCOPES"));
    })
    .finally(() => {
      setLoading(false);
    });
};
